import {Fragment, useState} from "react";
import {format} from "date-fns";
import {BreadCrumb, TablePaging, CenteredModal, FormInput} from "~/components";
import {faEdit} from "@fortawesome/free-solid-svg-icons";
import {useForm} from "react-hook-form";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import RouteAPI from '~/api/routeApi';
import {toast} from "react-toastify";

const breadCrumbItem = [
    { text: "Landing Page", to: "/ai-chatbot/administrator", isActive: false },
    { text: "Route", to: "", isActive: true },
]

function Route(){
    const [reloadTable, setReloadTable] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [errorUpdate, setErrorUpdate] = useState("");
    const tablePagingConfig = {
        columns: [
            {
                name: 'ID',
                width: '70px',
                className: 'fw-bold',
                key: 'RouteId'
            },
            {
                name: 'ROUTE TYPE',
                width: '150px',
                key: 'RouteType'
            },
            {
                name: 'ROUTE OPTION TITLE',
                width: '250px',
                key: 'RouteOptionTitle'
            },
            {
                name: 'ROUTE PATH',
                width: '300px',
                key: 'RoutePath'
            },
            {
                name: 'ROUTE CONTROLLER',
                width: '200px',
                key: 'RouteController'
            },
            {
                name: 'ROUTE ACTION',
                width: '130px',
                key: 'RouteAction'
            },
            {
                name: 'ACCESS COUNT',
                width: '150px',
                className: 'text-center',
                headerClassName: "text-center",
                key: 'AccessCount'
            },
            {
                name: 'MODIFIED BY',
                width: '150px',
                key: 'ModifiedBy'
            },
            {
                name: 'MODIFIED DATE',
                width: '150px',
                key: 'ModifiedDate',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.ModifiedDate), "dd-MM-yyyy")}</span>
                    )
                }
            },
            {
                name: 'ACTION',
                width: '70px',
                className: 'text-center',
                headerClassName: 'text-center',
                key: 'Action',
                template: (row) => {
                    return (
                        <span><FontAwesomeIcon onClick={()=> handleShowActionModal(row.RouteId)} icon={faEdit} className="text-primary cursor-pointer"/></span>
                    )
                }
            }
        ],
        url: "/routes/paged",
        tableKey: "TableRoute",
    }

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm();

    const handleShowActionModal = (routeId) => {
        setErrorUpdate("")
        RouteAPI.getById(routeId)
            .then(res => {
                reset(res.data);
                setShowModal(true);
            })
            .catch(error => {
                console.error(error)
            })
    }

    const onSubmitFrom = (data) => {
        RouteAPI.update(data)
            .then(res => {
                if(res.data?.Success){
                    setShowModal(false);
                    setReloadTable(prev => !prev);
                    toast.success(<span className="fs-9 fw-bold">Your route has been updated.</span>)
                }
                else{
                    if(res.data?.ReturnValue === -2){
                        setErrorUpdate(res.data?.Message);
                    }
                    else{
                        setShowModal(false);
                        toast.error(<span className="fs-9 fw-bold">An error occurred while updating your route.</span>)
                    }
                }
            })
            .catch(error => {
                setShowModal(false);
                toast.error(<span className="fs-9 fw-bold">An error occurred while updating your route.</span>)
            })
    }

    return (
       <Fragment>
           <BreadCrumb breadCrumbItem={breadCrumbItem}/>
           <h2 className="text-bold text-body-emphasis mb-5">Routes</h2>
           <TablePaging tablePagingConfig={tablePagingConfig} reloadTable={reloadTable}/>
           <CenteredModal
               show={showModal}
               onClose={() => setShowModal(false)}
               title="Edit Route"
               modalType="modal-lg"
               formId="formActionRoute"
           >
               <form onSubmit={handleSubmit(onSubmitFrom)} id="formActionRoute">
                   <div className="mb-3">
                       <div className="text-center">
                           {
                               errorUpdate && <span className="fs-9 fw-bold text-danger">{errorUpdate}</span>
                           }
                       </div>
                       <div className="row">
                           <div className="col-sm-6 col-12">
                               <FormInput showHeaderLabel={true}
                                          name="RouteType"
                                          disabled={true}
                                          label={`Assign Route Type`}
                                          maxLengthText=""
                                          validation={{...register("RouteType")}}
                               />
                           </div>
                           <div className="col-sm-6 col-12">
                               <FormInput showHeaderLabel={true}
                                          name="RouteOptionTitle"
                                          disabled={true}
                                          label={`Assign Route Option Title`}
                                          maxLengthText=""
                                          validation={{...register("RouteOptionTitle")}}
                               />
                           </div>
                           <div className="col-sm-6 col-12">
                               <FormInput showHeaderLabel={true}
                                          name="RouteController"
                                          errors={errors}
                                          label={`Assign Route Controller`}
                                          maxLengthText=""
                                          validation={{...register("RouteController", {
                                                  required: "Route controller is required."
                                              })}}
                                />
                           </div>
                           <div className="col-sm-6 col-12">
                               <FormInput showHeaderLabel={true}
                                          name="RouteAction"
                                          errors={errors}
                                          label={`Assign Route Action`}
                                          maxLengthText=""
                                          validation={{...register("RouteAction", {
                                                  required: "Route action is required."
                                              })}}
                               />
                           </div>
                       </div>
                       <FormInput showHeaderLabel={true}
                                  name="RoutePath"
                                  errors={errors}
                                  label={`Assign Route Path`}
                                  maxLengthText=""
                                  validation={{...register("RoutePath", {
                                          required: "Route path is required."
                                      })}}
                       />

                   </div>
               </form>
           </CenteredModal>
       </Fragment>
    )
}
export default Route;